module.exports = __webpack_public_path__ + "static/media/confirm-berth.14d24e7c.svg";